import { createSelector } from 'reselect';
import { RootState } from 'store';

const getDeviceDimensions = (state: RootState) => state.deviceDimensions;

export default createSelector([getDeviceDimensions], deviceDimensions => {
  return deviceDimensions && deviceDimensions.height < 500;
});
